import { ContactUsWidgetTypeEnum } from '@parkingbase/ecommerce-api-dev';
import { useContactUsStore } from '@/stores/contact-us.store';
import { resolveEffectiveSupportWidget } from '@/lib/support-widget-utils';

/// <reference types="@/types/support-widget" />

export function useSupportWidget() {
  const contactUs = useContactUsStore((s) => s.contactUs);
  // Same resolution as SupportWidgetProvider, so we drive the widget it actually loaded
  // (incl. the FreshDesk env fallback when ContactUs names no widget).
  const widgetType = resolveEffectiveSupportWidget(
    contactUs,
    process.env.NEXT_PUBLIC_FRESHDESK_KEY
  ).type;

  const isWidgetReady =
    typeof window !== 'undefined' &&
    ((widgetType === ContactUsWidgetTypeEnum.FRESHDESK &&
      typeof window.FreshworksWidget === 'function') ||
      (widgetType === ContactUsWidgetTypeEnum.ZENDESK && typeof window.zE === 'function'));

  const openWidget = () => {
    if (typeof window === 'undefined') return;

    if (widgetType === ContactUsWidgetTypeEnum.FRESHDESK && window.FreshworksWidget) {
      window.FreshworksWidget('open');
    } else if (widgetType === ContactUsWidgetTypeEnum.ZENDESK && window.zE) {
      window.zE('messenger', 'open');
    }
  };

  const closeWidget = () => {
    if (typeof window === 'undefined') return;

    if (widgetType === ContactUsWidgetTypeEnum.FRESHDESK && window.FreshworksWidget) {
      window.FreshworksWidget('close');
    } else if (widgetType === ContactUsWidgetTypeEnum.ZENDESK && window.zE) {
      window.zE('messenger', 'close');
    }
  };

  const identifyUser = (email: string, name: string) => {
    if (typeof window === 'undefined') return;

    if (widgetType === ContactUsWidgetTypeEnum.FRESHDESK && window.FreshworksWidget) {
      window.FreshworksWidget('identify', 'ticketForm', { email, name });
    }
  };

  return { openWidget, closeWidget, identifyUser, isWidgetReady };
}
